var PianoTrackerStatus = {
	NOT_LOADED: 'NOT_LOADED',
	LOADING: 'LOADING',
	LOADED: 'LOADED',
};
var _pianoTrackerStatus = PianoTrackerStatus.NOT_LOADED;

/**
 * An object to manage Piano Analytics as a TrackerManager plugin
 * @constructs PianoTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function PianoTracker(serverConfNode) {
	this.onScriptLoad = this.onScriptLoad.bind(this);

	this.siteId = serverConfNode.id;
	this.collectDomain = serverConfNode.collectDomain;
	this.loadTracker();
}

function isPaLoaded() {
	if (!window.pa) {
		console.error("Piano Analytics's pa global variable is not loaded");
		return false;
	}
	return true;
}

PianoTracker.prototype.isLoaded = function () {
	return _pianoTrackerStatus === PianoTrackerStatus.LOADED;
};

/**
 * Load the analytics tracker
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.loadTracker = function () {
	if (_pianoTrackerStatus !== PianoTrackerStatus.NOT_LOADED) {
		return;
	}
	_pianoTrackerStatus = PianoTrackerStatus.LOADING;
	// Inclusion du script Piano
	var script = document.createElement("script");
	script.setAttribute("type", "text/javascript");
	script.onload = this.onScriptLoad;
	script.src = 'https://tag.aticdn.net/piano-analytics.js';
	document.head.appendChild(script);

};

PianoTracker.prototype.onScriptLoad = function () {
	_pianoTrackerStatus = PianoTrackerStatus.LOADED;
	if (!isPaLoaded()) {
		return;
	}
	window.pa.setConfigurations({
		site: this.siteId,
		collectDomain: this.collectDomain,
	});
};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.trackPage = function (page, url, title) {
	if (!isPaLoaded()) {
		return;
	}
	window.pa.sendEvent('page.display', {
		page: title,
		url: url,
		wp_publication_path: page,
	});
};

/**
 * Track a page event
 * @param  {String}  wp_category The event category
 * @param  {String}  wp_action   The event name
 * @param  {String}  wp_label    The action label
 * @param  {integer} wp_value    A complementary figure
 * @author Andreï Cavoleau
 */
PianoTracker.prototype.trackEvent = function (wp_category, wp_action, wp_label, wp_value) {
	if (!isPaLoaded()) {
		return;
	}
	window.pa.sendEvent('wp_event', {
		wp_category: wp_category,
		wp_action: wp_action,
		wp_label: wp_label,
		wp_value: wp_value,
	});

};

module.exports = PianoTracker;


//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/pianoTracker.js
// module id = 801
// module chunks = 0